"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.color = void 0;

const color = (theme = {}, targetColor = '') => {
  const colorProp = theme[`bColor${targetColor}`] || targetColor;
  return colorProp;
};

exports.color = color;